import Dropdown from '@/components/Dropdown'
import useConfig from '@/hooks/use-config'
import "@/translations/i18n"
import rem from '@/utils/rem'
import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next"
import useBehalfPanel from '@/hooks/use-behalf-panel'

const AdditionalZone = ({ on_behalf_of, flow, callback, callbackInput }) => {

	const {t} = useTranslation();

    const [options, setOptions] = useState([{ name: t("select") }])
    const [selected, setSelected] = useState({ name: t("select") })
    const [ behalfPanel, setBehalfPanel ] = useBehalfPanel(on_behalf_of)
    const { fetch: fetchConfig } = useConfig()

	useEffect(() => {
        fetchConfig()
        setOptions([{ name: t("select"), id: 'no' }, ...on_behalf_of])
	}, [])

	useEffect(() => {
        if (selected) {
            callback(selected)
        }
	}, [selected])

    return ((flow === 'share' || behalfPanel) && (
        <>
            <div className="t--share-data-subheader">
                {t("additionalInformation")}
            </div>
            <div className="additional-zone">
                {behalfPanel && (<div className="additional-zone__item">
                        <div className="additional-box__header__title">
                            {t("onBehalfOf")} *
                        </div>
                        <div className="additional-box__header__input">
                            <Dropdown value={selected?.name} style={{ minWidth: rem(150) }}>
                                {options.map((option, index) => {
                                    return (
                                        <Dropdown.Item key={index}>
                                            <div onClick={() => setSelected(option)}>{option.name}</div>
                                        </Dropdown.Item>
                                    )
                                })}
                            </Dropdown>
                        </div>
                </div>)}
                {flow === 'share' && (<div className="additional-zone__item">
                        <div className="additional-box__header__title">
                            {t("referenceId")}
                        </div>
                        <div className="additional-box__header__input">
                            <input onChange={event => callbackInput(event.target.value)}/>
                        </div>
                </div>)}
            </div>
        </>)
    )
}

export default AdditionalZone;
